module.exports = __webpack_public_path__ + "img/渗透测试-bg.83d3c0ef.jpg";